// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".currentColor[data-v-45471052],.v-icon[data-v-45471052]{color:#393d47!important}", ""]);
// Exports
module.exports = exports;
